import firebase from 'firebase/app';

var firebaseConfig = {
  apiKey: 'AIzaSyAKMI43aASf3KOAVyXK3E2HDvXpv5bh41s',
  authDomain: 'seriesetfilms.firebaseapp.com',
  projectId: 'seriesetfilms',
  storageBucket: ''
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
